<template>
  <div class="article bg-grey">
    <div class="bg-white" style="padding-bottom: 75px">
      <div class="middle-main flex-row article-box">
        <div class="article-con">
          <!-- <img src="@/assets/images/banner.png" class="banner1" /> -->
          <h1>{{ detailsRes.newsTitle }}</h1>
          <div class="other-info justify-between items-center">
            <div class="items-center">
              <!-- <div class="items-center">
                <svg-icon icon-class="Group 1941"></svg-icon>
                <span>{{ detailsRes.releaseTime }}</span>
              </div> -->
              <div class="items-center" v-if="detailsRes.author">
                <!-- <svg-icon icon-class="pen"></svg-icon> -->
                <span>{{ detailsRes.author }}</span>
              </div>
              <!-- <div class="items-center">
                <svg-icon icon-class="Path 617"></svg-icon>
                <span>{{ detailsRes.tips }}</span>
              </div> -->
            </div>
            <!-- <div class="items-center">
              <div class="items-center">
                <div id="fb-root"></div>
                <div class="social-share" data-sites="qq,weibo,wechat,facebook"></div>
              </div>
            </div> -->
          </div>
          <div class="details" v-html="detailsRes.newsContent"></div>
          <div class="tags items-center" v-if="detailsRes.tag && detailsRes.tag.length > 0">
            <svg-icon icon-class="Group 3022"></svg-icon>
            <span v-for="item in detailsRes.tag" :key="item">{{ item }}</span>
          </div>

          <RelatedArticle v-if="detailsRes.typeId === 20" :author="detailsRes.newsTitle" />
        </div>
        <div class="relate-news">
          <!-- <img src="@/assets/images/magazine.jpg" class="banner2" />
          <div class="news-list">
            <h2>熱門新聞</h2>
            <div
              class="news-item items-center hand"
              v-for="item in newsListRes"
              :key="item.newsId"
              @click="toDetails(item)"
            >
              <img :src="item.newsImage" />
              <div class="info">
                <time>{{ item.releaseTime }}</time>
                <h3>{{ item.newsTitle }}</h3>
              </div>
            </div>
          </div> -->
          <!-- <img
            src="@/assets/images/join.gif"
            class="banner3 hand"
            @click="toJoin"
          /> -->
          <div class="news-list">
            <h3>
              你可能喜欢
              <span>
                <svg-icon icon-class="change"></svg-icon>
                <span>换一批</span>
              </span>
            </h3>
            <news-list :newsId="detailsRes.newsId+''" img-direction="flex-col" :ispagination="false" />

            <!-- <div class="news-item flex-col hand" v-for="item in newsListRes2" :key="item.newsId"
              @click="toDetails(item.newsId)">
              <img :src="item.newsImage" />
              <div class="info">
                <time>{{ item.releaseTime }}</time>
                <h3>{{ item.newsTitle }}</h3>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import swiperPolicy from "../common/swiper-policy.vue";
import newsList from "../common/news-list.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { getNewsDetails, getNewsList } from "@/assets/api/news.js";
import RelatedArticle from './components/related-article.vue'

export default {
  components: {
    swiper,
    swiperSlide,
    swiperPolicy,
    newsList,
    RelatedArticle,
  },

  data() {
    return {
      detailsRes: {},
      newsListRes: [],
      newsListRes2: [],
      swiperOption2: {
        slidesPerView: 2, //一页显示几个
        spaceBetween: 16, //每一个之间的距离
        slidesOffsetBefore: 0, //距离左边的距离
        slidesOffsetAfter: 0, //距离右边的距离
        centeredSlides: true,
        loop: false,
        speed: 1000,
        autoplay: {
          delay: 30000, //自动切换的时间间隔
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
        navigation: {
          nextEl: ".swiper-button-next2", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev2", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled2", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden2", //按钮隐藏时的Class
        },
      },
    };
  },
  created() {
    getNewsDetails(this.$route.params.id).then((res) => {
      this.detailsRes = res.data.data;
      this.detailsRes.tag = this.detailsRes.tag
        ? this.detailsRes.tag.split("|")
        : [];

      let cfg = {
        url: 'https://www.ts960.com/share/article/' + this.detailsRes.newsId + '.html', // 网址，默认使用 window.location.href
        // source              : '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: this.detailsRes.newsTitle, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        // origin              : '', // 分享 @ 相关 twitter 账号
        // description         : '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        // image               : '', // 图片, 默认取网页中第一个img标签
        // title               : '234',
        // description         : '123',
        // sites               : ['qq', 'weibo','wechat', 'facebook'], // 启用的站点
        // disabled            : ['douban', 'diandian'], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper: '<p>微信扫一扫</p><p>二维码便可将本文分享至朋友圈。</p>',
      };

      socialShare('.social-share', cfg);
    });
    getNewsList({
      orderByColumn: "releaseTime",
      isAsc: "desc",
      typeId: "13",
      newsId: this.$route.params.id,
      pageNum: 1,
      pageSize: 5,
      slideshow: 0,
    }).then((res) => {
      this.newsListRes = res.data.rows.map((item) => {
        item.newsImage = !/^http/.test(item.newsImage)
          ? this.$imgUrl + item.newsImage
          : item.newsImage;
        return item;
      });
    });
    getNewsList({
      orderByColumn: "releaseTime",
      isAsc: "desc",
      newsId: this.$route.params.id,
      pageNum: 1,
      pageSize: 5,
      slideshow: 0,
    }).then((res) => {
      this.newsListRes2 = res.data.rows.map((item) => {
        item.newsImage = !/^http/.test(item.newsImage)
          ? this.$imgUrl + item.newsImage
          : item.newsImage;
        return item;
      });
    });
  },
  methods: {
    tofacebook() {
      let vm = this;
      console.log(window.location.href);
      FB.init({
        appId: "1951935595172355",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v2.12",
      });
      FB.ui(
        {
          method: "share", // 分享方式
          mobile_iframe: true,
          href: `https://ts960.com/share/article/${vm.detailsRes.newsId}.html`, // 分享的连接
        },
        function (response) { }
      );
    },
    toJoin() {
      this.$router.push({
        path: `/about`,
      });
    },
    // toDetails(item, url) {
    //   if (url) {
    //     window.open(url, "_blank");
    //   } else {
    //     if (item.price > 0) {
    //       this.$router.push({
    //         path: `/expert-details/${item.newsId}`,
    //       });
    //     } else {
    //       this.$router.push({
    //         path: `/article-details/${item.newsId}`,
    //       });
    //     }
    //   }
    // },
  },
};
</script>
<style lang="less" scoped>
.article {
  margin-top: 30px;
}

.article-con {
  flex: 1;

  .banner1 {
    width: 100%;
    height: 240px;
    object-fit: cover;
  }

  h1 {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 40px;
    color: #2C2C2E;
    line-height: 52px;
    text-align: left;
    font-style: normal;
    padding: 40px 0 16px;
  }

  .other-info {
    margin-bottom: 40px;

    span {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #636366;
      line-height: 19px;
      text-align: left;
      font-style: normal;
    }
  }

  .details {
    line-height: 2.19;
    letter-spacing: 0.8px;
    color: #000;
  }

  .tags {
    margin-top: 50px;

    .svg-icon {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }

    span {
      font-family: NotoSansCJKTC;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.58;
      letter-spacing: 1.2px;
      text-align: center;
      color: #e13133;
      padding: 3px 24px;
      border: solid 1px #e13133;
      margin-right: 10px;
    }
  }

  .other-news {
    width: 100%;

    .swiper-slide {
      width: 100%;
    }
  }
}

.relate-news {
  width: 320px;
  margin-left: 30px;

  .banner2 {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .banner3 {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .news-list {
    h3 {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 32px;
      color: #2C2C2E;
      line-height: 42px;
      text-align: left;
      font-style: normal;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 40px 0 30px;

      span {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #AEAEB2;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        cursor: pointer;
      }

    }

    h2 {
      font-family: NotoSansCJKTC;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 29px;
      letter-spacing: normal;
      text-align: left;
      color: #222;
      padding: 6px 0;
      margin-top: 15px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e13133;
    }

    .news-item {
      margin-bottom: 10px;

      img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        margin-right: 10px;
      }

      time {
        font-family: NotoSansCJKTC;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71;
        letter-spacing: 0.7px;
        text-align: center;
        color: #8b8b8b;
        margin-bottom: 2px;
      }

      h3 {
        font-family: NotoSansCJKTC;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 2.4px;
        text-align: left;
        color: #222;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
    }
  }
}

.other-news {
  padding: 40px 0 80px;
}

@media screen and (max-width: 768px) {
  .article {
    margin-top: 0;

    .article-con {
      flex: 1;

      .banner1 {
        width: 100%;
        height: auto;
        object-fit: cover;
      }

      h1 {
        font-size: 18px;
        padding: 15px;
      }

      .other-info {
        padding: 0;
        padding-bottom: 10px;
        border-bottom: 1px solid #e13133;
        margin: 0 15px;
        margin-bottom: 16px;

        div {
          margin-right: 12px;
        }

        .svg-icon {
          width: 16px;
          height: 16px;
          margin-right: 3px;
        }

        span {
          font-family: NotoSansCJKTC;
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.09;
          letter-spacing: normal;
          text-align: left;
          color: #e13133;
        }
      }

      .details {
        line-height: 2.19;
        letter-spacing: 0.8px;
        color: #000;
      }

      .tags {
        margin: 30px 15px;
      }

      .other-news {
        width: 100%;

        .swiper-slide {
          width: 100%;
        }
      }
    }

    .relate-news {
      width: 100%;
      padding: 0 15px;
      margin: 0;

      .banner2 {
        width: 100%;
        height: auto;
        object-fit: cover;
      }

      .banner3 {
        width: 100%;
        height: auto;
        object-fit: cover;
      }

      .news-list {
        h2 {
          font-family: NotoSansCJKTC;
          font-size: 20px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 29px;
          letter-spacing: normal;
          text-align: left;
          color: #222;
          padding: 6px 0;
          margin-top: 15px;
          margin-bottom: 20px;
          border-bottom: 1px solid #e13133;
        }

        .news-item {
          margin-bottom: 10px;

          img {
            width: 100px;
            height: 100px;
            object-fit: cover;
            margin-right: 10px;
          }

          time {
            font-family: NotoSansCJKTC;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.71;
            letter-spacing: 0.7px;
            text-align: center;
            color: #8b8b8b;
            margin-bottom: 2px;
          }

          h3 {
            font-family: NotoSansCJKTC;
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: 2.4px;
            text-align: left;
            color: #222;
          }
        }
      }
    }
  }

  .article-box {
    flex-direction: column;
  }
}
</style>
<style>
.details img {
  display: block;
  max-width: 90%;
  height: auto;
  margin: 35px auto;
}

.details video {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.details iframe {
  width: 100%;
  height: 500px;
  max-width: 100%;
}

@media screen and (max-width: 768px) {
  .details img {
    max-width: 100%;
    margin: 15px auto;
  }

  .details iframe {
    width: 100%;
    height: 300px;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/video-details/index.vue